
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/take-quiz/jst/fileUploadedOrRemoved';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n  <div class=\"file-status file-uploaded\">\n    <em role=\"alert\" aria-live=\"assertive\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.file_uploaded_or_removed")
  },data:data},helper ? helper.call(depth0, "quizzes.file_uploaded_or_removed.quizzes.file_successfully_uploaded", "Your file has been successfully uploaded.", options) : helperMissing.call(depth0, "t", "quizzes.file_uploaded_or_removed.quizzes.file_successfully_uploaded", "Your file has been successfully uploaded.", options)))
    + "\n    </em>\n  </div>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div class=\"file-status file-removed\">\n    <em role=\"alert\" aria-live=\"assertive\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'display_name': ((depth0 && depth0.display_name)),
    'i18n_scope': ("quizzes.file_uploaded_or_removed")
  },data:data},helper ? helper.call(depth0, "quizzes.file_uploaded_or_removed.quizzes.files_removed", "%{display_name} has been removed.", options) : helperMissing.call(depth0, "t", "quizzes.file_uploaded_or_removed.quizzes.files_removed", "%{display_name} has been removed.", options)))
    + "\n    </em>\n  </div>\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.fileUploaded), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  